import React from 'react';
import type { I18nLike } from '@bingads-webui/common-types';
import PropTypes from 'prop-types';
import { mergeClasses } from '@fluentui/react-components';
import {
  EmptyState,
  EmptyStateAction,
  EmptyStateLink,
  EmptyStateContent,
  EmptyStateSize,
  EmptyStateSurfaceIcon,
  SurfaceIcons,
} from '@adsui/empty-state';
import { useFluentErrorViewStyles } from './fluent-error-view-styles';

export type BrowserDeprecationViewI18n = I18nLike & Required<Pick<I18nLike, 'getLocale'>>;

export interface BrowserDeprecationViewProps {
  className?: string;
  i18n: BrowserDeprecationViewI18n;
}

function getHelpContentHref(i18nLocale: string) {
  const splits = i18nLocale.split('-');
  let localeCode = splits[0] || 'en';

  if (localeCode === 'pt') {
    localeCode = 'pt-BR';
  }

  return `https://help.ads.microsoft.com/#apex/ads/${localeCode}/52033/0`;
}

export function BrowserDeprecationView({
  className,
  i18n,
}: BrowserDeprecationViewProps) {
  const styles = useFluentErrorViewStyles();
  const title = i18n.getString(_TL_('The site is incompatible with your browser'));
  const subtext = i18n.getString(_TL_('Please find the list of supported browser from'));

  return (
    <EmptyState className={mergeClasses(className, styles.emptyStateContainer)} size={EmptyStateSize.largeSurface}>
      <EmptyStateContent
        title={title}
        subtext={subtext}
      >
        <EmptyStateSurfaceIcon icon={SurfaceIcons.SearchQuestionMark} />
      </EmptyStateContent>
      <EmptyStateAction>
        <EmptyStateLink
          href={getHelpContentHref(i18n.getLocale())}
        >
          {i18n.getString(_TL_('this page'))}
        </EmptyStateLink>
      </EmptyStateAction>
    </EmptyState>
  );
}

BrowserDeprecationView.propTypes = {
  className: PropTypes.string,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    getLocale: PropTypes.func.isRequired,
  }).isRequired,
};

BrowserDeprecationView.defaultProps = {
  className: '',
};
